import { SortingField } from '../../../swagger/dtoGateway'

export const Filter = [
    {
        title: 'По дате',
        value: SortingField.LastModified,
    },
    {
        title: 'По названию',
        value: SortingField.Filename,
    },
    {
        title: 'По размеру',
        value: SortingField.Size,
    },
]
